import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProductService } from 'src/app/services/product.service';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import { GenericValidator } from 'src/app/views/layout/validators/generic-validator';
import { AlertService } from 'src/app/services/alert.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { Router } from '@angular/router';
import { DealerService } from 'src/app/services/dealer.service';
import { Location } from '@angular/common';




@Component({
  selector: 'app-dealerrejectpopup',
  templateUrl: './dealerrejectpopup.component.html',
  styleUrls: ['./dealerrejectpopup.component.scss']
})
export class DealerrejectpopupComponent implements OnInit {
  showNotes: boolean;
  form: FormGroup;
  dealerList: any[];
  dealerListDetail: any[];






  constructor(private formBuilder: FormBuilder, public dialog: MatDialog, private router: Router,
    public navigationService: NavigationService, private dealerService: DealerService,
    @Inject(MAT_DIALOG_DATA) public data: any, private manufacturerService: ManufacturerService,
    private _location: Location,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<DealerrejectpopupComponent>,) { }


  ngOnInit() {
    this.showNotes = true;
    this.initializeValidators();
   // this.get();
  }

  initializeValidators() {

    this.form = this.formBuilder.group({
      remarks: ['', Validators.required]
    })
  }

  get() {

    this.dealerService.getdealerDetails(true).subscribe(res => {
      if (res) {
        this.dealerList = [];
        this.dealerListDetail = [];
        this.dealerList = res;
        this.dealerListDetail = this.dealerList.slice();

      }
    })
  }

  // next(id: number, actionInfo: number, viewactionInfo: number) {
  //   this.navigationService.goTODealerview(id, actionInfo, viewactionInfo);
  // }

  next() {
    this.dialogRef.close();
    // this.navigationService.goTODealerview(this.data, 3,3 );
  }

  goToAction(item: number) {
    if(this.form.valid){
    var data = {

      id: this.data.id,
      approvedStatusType: item,
      remarks: this.form.value.remarks
    }
    this.dealerService.dealerApproval(data).subscribe(res => {
    
      if (res && res.isSuccess) {
        this.alertService.success('Rejected Successfully');
        this._location.back();
      }
      
    });
  }
  else {
    this.alertService.error("Please enter the rejection remarks");
  }
  }

}
